<template>
  <div>
    <input type="text" v-model="searchText" @input="searchCryptos" >
    <p style="text-align:left">Xignite Search Results</p>
    <ul class="crypto-list">
      <li @click="emitSelected(crypto.Symbol)" v-for="crypto in cryptos" :key="crypto.Symbol">{{ crypto.Name }} ({{crypto.Symbol}})</li>
    </ul>
  </div>
</template>
<style>
.crypto-list {
    width: 100%;
    height: 8em;
    line-height: 2em;
    border: 1px solid #ccc;
    padding: 0;
    margin: 0;
    overflow: scroll;
    overflow-x: hidden;
    text-align: left;
}
.crypto-list li:hover {
  background-color: pink;
  cursor: pointer;
}
</style>
<script>

export default {
  props: ['supportedCryptos'],
  data() {
    return {
      searchText: '',
      cryptos: [],
    };
  },
  methods: {
    emitSelected(symbol) {
      this.$emit('picked', symbol);
    },
    searchCryptos() {
      this.cryptos = this.$props.supportedCryptos.filter(crypto => crypto.Name.toLowerCase().startsWith(this.searchText.toLowerCase()));
    },
  },
};
</script>
